export default __webpack_public_path__ + "static/media/backgroundCity.c5913171.png";